import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { CloseButton as DCCloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';

interface KeywordFiltersProps {
  hasContent: boolean;
}

export const KeywordFilters = styled(Box).attrs({
  horizontal: true,
  flexWrap: 'wrap',
  gridGap: '8px',
})<KeywordFiltersProps>`
  margin-bottom: ${({ hasContent }) => (hasContent ? '12px' : '0px')};
`;

export const KeywordFilterPill = styled(Box).attrs({
  backgroundColor: 'lightLineDivider',
  padding: '4px',
  borderRadius: '5px',
  horizontal: true,
})``;

export const KeywordFilterPillCloseButton = styled(DCCloseButton).attrs({
  color: 'primaryText',
})`
  margin-left: 7px;
`;

export const KeywordText = styled(Text).attrs({
  inline: true,
  size: 'normal',
  color: 'primaryText',
})``;

export const TranscriptMatchSortContent = styled(Box).attrs({
  horizontal: true,
  gridGap: '5px',
  color: 'primaryText',
  fontSize: 'normal',
  align: 'center',
})``;

export const ClickableIcon = styled(Box).attrs({
  px: '5px',
  py: '4px',
  cursor: 'pointer',
  color: 'secondaryLink',
})``;
